import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { AssessmentWorkItemEvidenceSummary, workItemStatusPresentation } from "../../services/assessment_work_items.types";
import { AssessmentTaskRequirementRef } from "../../services/assessment_tasks.types";
import { encodeBase64RouteValue } from "../../utils/base64_route_value.util";
import { formatDateTimeDisplay } from "../../utils/date_time_display.util";
import { evidenceRequirementDueState } from "../../utils/evidence_requirement_due_date.util";

@Component({
    selector: "app-evidence-work-item-card",
    templateUrl: "./evidence_work_item_card.component.html",
    styleUrls: ["./evidence_work_item_card.component.scss"]
})
export class EvidenceWorkItemCardComponent implements OnChanges {
    @Input({ required: true }) evidence!: AssessmentWorkItemEvidenceSummary;
    @Input() assessmentRoute: UrlTree | null = null;
    @Input() mutationPending = false;
    @Output() edit = new EventEmitter<void>();
    @Output() delete = new EventEmitter<void>();
    @Output() email = new EventEmitter<void>();
    @Output() upload = new EventEmitter<void>();
    @Output() linkedFile = new EventEmitter<"download" | "preview" | "manage">();
    @Output() navigate = new EventEmitter<void>();

    readonly formatDateTime = formatDateTimeDisplay;
    readonly evidenceDueState = evidenceRequirementDueState;
    readonly requirementLinks = new Map<string, UrlTree>();

    constructor(private readonly router: Router) {}

    get statusPresentation() {
        return workItemStatusPresentation({ kind: "evidence", evidence: this.evidence });
    }

    requirementLinkKey(requirement: AssessmentTaskRequirementRef): string {
        return JSON.stringify([requirement.sectionKey, requirement.requirementKey]);
    }

    ngOnChanges(): void {
        this.requirementLinks.clear();
        // Only a freshly authorized assessment route admits mapped-control navigation.
        if (!this.assessmentRoute) return;
        for (const requirement of this.evidence.requirements) {
            const section = "navigationSectionKey" in requirement && typeof requirement.navigationSectionKey === "string"
                ? requirement.navigationSectionKey : requirement.sectionKey;
            const key = "navigationRequirementKey" in requirement && typeof requirement.navigationRequirementKey === "string"
                ? requirement.navigationRequirementKey : requirement.requirementKey;
            try {
                encodeURIComponent(section);
                encodeURIComponent(key);
            } catch { continue; }
            const activeSection = encodeBase64RouteValue(section);
            const activeRequirement = encodeBase64RouteValue(key);
            if (!/^[A-Za-z0-9+/]+={0,2}$/.test(activeSection) ||
                !/^[A-Za-z0-9+/]+={0,2}$/.test(activeRequirement)) continue;
            const route = this.router.parseUrl(this.assessmentRoute.toString());
            route.queryParams = { ...route.queryParams, activeSection, activeRequirement };
            this.requirementLinks.set(this.requirementLinkKey(requirement), route);
        }
    }
}
